import { ButtonsColorType, ButtonsType } from "../../../../types/enums";
import { useAppDispatch, useAppSelector } from "../../../../hooks";
import { selectPermissions } from "../../../../features/permissionsSlice";
import {
  campaignsApi,
  recommendedApi,
  RecommendedTags,
  useGenerateRecommendedAccountsMutation,
} from "../../../../api";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { CustomToast } from "../../CustomToast";
import { getErrorMessage } from "../../../../utils/getErrorMessage";
import { CircularProgress } from "@mui/material";
import { ReuseButton } from "../../ReuseButton";

type Props = {
  isLoading: boolean;
};
export const FindSimilarAccountsBtn = ({ isLoading }: Props) => {
  const dispatch = useAppDispatch();
  const { campaign_id } = useParams();
  const { isAllowedShareAccess } = useAppSelector(selectPermissions);

  const [generateRecommendedAccounts, { isLoading: isGeneratingRecommended }] =
    useGenerateRecommendedAccountsMutation();
  useGenerateRecommendedAccountsMutation();

  const generateRecommendedHandler = () => {
    if (!campaign_id) return;
    generateRecommendedAccounts({ campaign_id })
      .unwrap()
      .then(() => {
        dispatch(campaignsApi.util.invalidateTags(["summary"]));
        dispatch(
          recommendedApi.util.invalidateTags([
            RecommendedTags.recommended_filters,
          ]),
        );
      })
      .catch((err) =>
        toast.error(
          <CustomToast
            type="error"
            text={
              getErrorMessage(err).globalError ||
              "Something went wrong. Please try again"
            }
            title="Failed to generate recommended accounts"
          />,
        ),
      );
  };

  return (
    <ReuseButton
      buttonType={ButtonsType.contained}
      buttonColor={ButtonsColorType.gradient}
      onClick={generateRecommendedHandler}
      disabled={!isAllowedShareAccess || isLoading || isGeneratingRecommended}
      startIcon={
        (isLoading || isGeneratingRecommended) && (
          <CircularProgress size={20} sx={{ color: "inherit" }} />
        )
      }
    >
      Find Similar Accounts
    </ReuseButton>
  );
};
